import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)



// 公共路由
export const constantRoutes = [
  {
    path: '/family/:id/:type*',
    component: () => import('@/views/family'),
    name: 'Family'
  },
  {
    path: '/material/:id/:type*',
    component: () => import('@/views/material'),
    name: 'Material'
  }
]

export default new Router({
  mode: 'hash', // 去掉url中的#
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes
})
